import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Button, CheckBox, DateBox, SelectBox, Validator, ValidationGroup } from "devextreme-react";
import { setHideShowWizard, setOpening, setConfigShedulerWizard, setStepWizard, doGetConfigurations, doGetCenterConfiguration, doGetFeriadosAdmin, resetOpeningState } from "../actions";
import moment from "moment";
import helper from "../../../../../../helpers/validaciones";
import RangeHoursWeek from "../../../../../Shared/rangeHours";
import LoadingOverlay from "../../../../../Shared/LoadingOverlay";
import constants from "../../../../../../helpers/constants";
const moduleTimeList = [15, 30, 45, 60];

class formConfigApertura extends React.Component {
  componentDidUpdate = (prevProps) => {
    if (this.props.isPopupWizardOpen && !prevProps.isPopupWizardOpen) {
      this.props.dispatch(doGetFeriadosAdmin(this.props.centerId));
      this.props.dispatch(doGetCenterConfiguration(this.props.centerId));
    }
  }

  handleClose = () => {
    this.props.dispatch(setHideShowWizard(false));
    this.props.dispatch(resetOpeningState(this.props.centerId));
  }

  HandleChangeChoseDays = (check, week) => {
    const NewOpening = { ...this.props.Opening };

    let workDays = [];
    if (check.value) {
      if (NewOpening.workDays && NewOpening.workDays.length > 0) {
        workDays = NewOpening.workDays;
      }
      workDays.push({ index: week.index, day: week.day, order: week.order });
    } else {
      workDays = NewOpening.workDays.filter((d) => d.day !== week.day);
    }
    NewOpening.workDays = workDays;
    NewOpening.satWorking = workDays.find((s) => s.day === constants.sabado) !== undefined;
    NewOpening.sunWorking = workDays.find((s) => s.day === constants.domingo) !== undefined;
    NewOpening.weekWorking = workDays.find((s) => s.day !== constants.sabado && s.day !== constants.domingo) !== undefined;
    if (NewOpening.IdConfig > 0) {
      NewOpening.isNewConfig = true;
    }
    if (!NewOpening.weekWorking) {
      NewOpening.startWorkDay = null;
      NewOpening.endWorkDay = null;
    }
    if (!NewOpening.sunWorking) {
      NewOpening.sunWorkStart = null;
      NewOpening.sunWorkEnd = null;
    }
    if (!NewOpening.satWorking) {
      NewOpening.satWorkEnd = null;
      NewOpening.satWorkstart = null;
    }
    NewOpening.startDate = null;
    NewOpening.endDate = null;
    this.props.dispatch(setOpening(NewOpening));
  }

  concatDateAndTime = (date, time) => {
    const soloFecha = moment(new Date(date), "DD-MM-YYYY").format("DD-MM-YYYY");
    const soloHora = moment(time, "HH:mm").format("HH:mm");
    const fechaHora = `${soloFecha} ${soloHora}`;
    return new Date(moment(fechaHora, "DD-MM-YYYY HH:mm").format("MM-DD-YYYY HH:mm"));
  }

  handleChangeDesde = (e) => {
    const NewOpening = { ...this.props.Opening };
    if (e.value !== null) {
      const start = this.concatDateAndTime(e.value, NewOpening.startWorkDay);
      NewOpening.startDate = start;
    } else {
      NewOpening.startDate = null;
    }
    this.props.dispatch(setOpening(NewOpening));
  }
  handleChangeHasta = (e) => {
    const NewOpening = { ...this.props.Opening };
    if (e.value !== null) {
      NewOpening.endDate = this.concatDateAndTime(e.value, NewOpening.endWorkDay);
    } else {
      NewOpening.endDate = null;
    }
    this.props.dispatch(setOpening(NewOpening));
  }
  handleChangeWorkDay = (data) => {
    const NewOpening = { ...this.props.Opening };
    NewOpening.startWorkDay = data.value.from;
    NewOpening.endWorkDay = data.value.to;
    if (NewOpening.IdConfig > 0) {
      NewOpening.isNewConfig = true;
    }
    this.props.dispatch(setOpening(NewOpening));
  }
  handleChangeSatWorkDay = (data) => {
    const NewOpening = { ...this.props.Opening };
    NewOpening.satWorkstart = data.value.from;
    NewOpening.satWorkEnd = data.value.to;
    if (NewOpening.IdConfig > 0) {
      NewOpening.isNewConfig = true;
    }
    this.props.dispatch(setOpening(NewOpening));
  }
  handleChangeSunWorkDay = (data) => {
    const NewOpening = { ...this.props.Opening };
    NewOpening.sunWorkStart = data.value.from;
    NewOpening.sunWorkEnd = data.value.to;
    if (NewOpening.IdConfig > 0) {
      NewOpening.isNewConfig = true;
    }
    this.props.dispatch(setOpening(NewOpening));
  }

  handleChangModuleTime = (e) => {
    const Opening = { ...this.props.Opening };
    Opening.moduleTime = e.value;
    if (Opening.IdConfig > 0) {
      Opening.isNewConfig = true;
    }
    this.props.dispatch(setOpening(Opening));
  }
  handleChangeConfiguration = (e) => {
    // seteo los valores que posee la configuracion
    const NewOpening = { ...this.props.Opening };
    if (e.value !== 0) {
      this.props.dispatch(doGetConfigurations(NewOpening, e.value));
    } else {
      this.props.dispatch(resetOpeningState(this.props.centerId));
    }
  }

  createPriority = (workDays) => {
    const priorityData = [];
    workDays.forEach((item) => {
      // Configuracion de la matriz
      const pivot = helper.getDaysIndex(item.day);
      priorityData.push({
        text: helper.capitalizeFirstLetter(pivot.name),
        id: pivot.index,
        order: pivot.order,
      });
    });
    return priorityData.sort((a, b) => a.order - b.order);
  }
  createQuoteMatrix = (workDays, NewOpening) => {
    const data = [];
    workDays.forEach((item) => {
      let configStart;
      let configEnd;
      switch (item.day) {
        case "sábado": {
          configStart = moment(NewOpening.satWorkstart, "HH:mm").format("HH:mm");
          configEnd = moment(NewOpening.satWorkEnd, "HH:mm").format("HH:mm");
          break;
        }
        case "domingo": {
          configStart = moment(NewOpening.sunWorkStart, "HH:mm").format("HH:mm");
          configEnd = moment(NewOpening.sunWorkEnd, "HH:mm").format("HH:mm");
          break;
        }
        default:
          configStart = moment(NewOpening.startWorkDay, "HH:mm").format("HH:mm");
          configEnd = moment(NewOpening.endWorkDay, "HH:mm").format("HH:mm");
          break;
      }
      // ciclo para crear la matriz para una apertura con nueva configuracion
      let start = this.concatDateAndTime(new Date(), configStart);
      const end = this.concatDateAndTime(new Date(), configEnd);
      while (end > start) {
        const NewStartDate = start;
        start = new Date(start.getTime() + (parseInt(NewOpening.moduleTime, 10) * 60 * 1000));
        const s = moment(NewStartDate);
        const e = moment(start);
        data.push({
          day: item.order || (item.index === 0 ? 7 : item.index),
          startDate: NewStartDate,
          endDate: start,
          startDateInt: NewStartDate.setHours(s.hour(), s.minutes(), 0, 0),
          endDateInt: start.setHours(e.hour(), e.minutes(), 0, 0),
          Quotas: this.props.listQuotes,
        });
      }
    });
    return data;
  }
  handleNext = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) {
      const NewOpening = { ...this.props.Opening };
      const workDays = NewOpening.workDays.sort((a, b) => a.index - b.index);
      if (NewOpening.oldData != null) NewOpening.data = NewOpening.oldData;
      let data = [];
      const priorityData = this.createPriority(workDays);
      if (NewOpening.IdConfig === 0) {
        NewOpening.Ciel = this.props.centerConfig.listCiel.map((i) => i.id);
        NewOpening.Exams = this.props.centerConfig.listExams.map((i) => i.id);
        NewOpening.ExamPools = this.props.centerConfig.listExamPools.map((i) => i.id);
        // Generar semana tipo con valores en cuota 0
        data = [...this.createQuoteMatrix(workDays, NewOpening)];
      }

      if (NewOpening.IdConfig > 0) {
        // ciclo para crear la matriz para una nueva apertura desde una configuracion historica
        if (NewOpening.isNewConfig !== true) {
          const loopConfig = [...NewOpening.data];
          loopConfig.forEach((conf) => {
            const s = moment(this.concatDateAndTime(new Date(), conf.StartTime));
            const e = moment(this.concatDateAndTime(new Date(), conf.EndTime));
            data.push({
              day: conf.Day === 0 ? 7 : conf.Day,
              startDate: this.concatDateAndTime(new Date(), conf.StartTime),
              endDate: this.concatDateAndTime(new Date(), conf.EndTime),
              startDateInt: this.concatDateAndTime(new Date(), conf.StartTime).setHours(s.hour(), s.minutes(), 0, 0),
              endDateInt: this.concatDateAndTime(new Date(), conf.EndTime).setHours(e.hour(), e.minutes(), 0, 0),
              Quotas: conf.Quotas,
            });
          });
        } else {
          data = [...this.createQuoteMatrix(workDays, NewOpening)];
        }
      }
      if (NewOpening.data && NewOpening.data.length) {
        NewOpening.oldData = [...NewOpening.data];
      }
      NewOpening.data = [...data];
      const momentsMax = data.map((d) => moment(d.endDate));
      const momentsMin = data.map((d) => moment(d.startDate));
      const config = {
        startDayHour: this.getTimeAsFloat(momentsMin, false),
        endDayHour: this.getTimeAsFloat(momentsMax, true),
        cellDuration: parseInt(NewOpening.moduleTime, 10),
      };
      NewOpening.priorityData = priorityData;
      this.props.dispatch(setConfigShedulerWizard(config));
      this.props.dispatch(setOpening(NewOpening));
      this.props.dispatch(setStepWizard({
        stepOne: false,
        stepTwo: true,
        stepThree: false,
        stepSuccess: false,
      }));
    }
  }

  getTimeAsFloat = (time, isMax) => {
    let totalHour = isMax ? parseInt(moment.max(time).format("HH")) : parseInt(moment.min(time).format("HH"));
    const minutes = isMax ? parseInt(moment.max(time).format("mm")) : parseInt(moment.min(time).format("mm"));

    if (minutes === 15) { totalHour += 0.25; }
    if (minutes === 30) { totalHour += 0.5; }
    if (minutes === 45) { totalHour += 0.75; }
    return totalHour;
  }

  shouldDisableCalendarDay = (data) => {
    const day = new Date(data.date).getDay();
    return this.props.Opening.workDays.findIndex((i) => i.index === day) === -1;
  }

  renderJornadaTrabajo = (item, index) => {
    let checked = false;
    const NewOpening = { ...this.props.Opening };
    if (NewOpening.workDays && NewOpening.workDays.length > 0) {
      checked = NewOpening.workDays.find((d) => d.day.toLowerCase() === item.day.toLowerCase()) !== undefined;
    }

    return (

      <div key={index + item.day} className="grid-jornada-laboral-item">
        <CheckBox
          key={index + item.day}
          text={helper.capitalizeFirstLetter(item.day)}
          onValueChanged={(check) => this.HandleChangeChoseDays(check, item, index)}
          value={checked}
        >
          <Validator
            validationRules={[{
              type: "custom",
              validationCallback: () => this.props.Opening.workDays && this.props.Opening.workDays.length !== 0,
              message: "Debe seleccionar al menos un día",
            }]}
          />
        </CheckBox>
      </div>

    );
  }
  render() {
    const {
      Opening,
      centerConfig,
    } = this.props;

    return (
      <React.Fragment>
        {Opening.IdCentro !== null && (
          <React.Fragment>
            {this.props.isModalWizardLoading && <LoadingOverlay />}
            <ValidationGroup>
              <div className="col-12" style={{ marginTop: 10 }}>
                <h3><p>Configuraciones</p></h3>
                <SelectBox
                  label="Configuraciones"
                  Id="configuraciones"
                  searchEnabled
                  placeholder="Lista de configuraciones"
                  defaultValue={Opening.IdConfig}
                  dataSource={this.props.configList}
                  displayExpr="NameConfig"
                  valueExpr="IdConfig"
                  onValueChanged={this.handleChangeConfiguration}
                >
                  <Validator
                    validationRules={[{
                      type: "required",
                      message: "Este campo es requerido",
                    }]}
                  />
                </SelectBox>
              </div>
              <div className="col-12" style={{ marginTop: 10 }}>
                <h3><p>Jornada de trabajo</p></h3>
                <div className="grid-jornada-laboral">
                  {centerConfig.listDaysWorking.map((item, index) => this.renderJornadaTrabajo(item, index))}
                </div>
              </div>
              <div className="row col-12" style={{ marginTop: 10 }}>

                <div className="col-4">
                  <h3><p>Horario Semana Laboral</p></h3>
                  <RangeHoursWeek
                    key="hourWorkDay"
                    column="hourWorkDay"
                    disabled={!Opening.weekWorking}
                    callBackHours={(data) => this.handleChangeWorkDay(data)}
                    min={this.concatDateAndTime(new Date(), centerConfig.minWorkDay)}
                    max={this.concatDateAndTime(new Date(), centerConfig.maxWorkDay)}
                    useData={Opening.IdConfig}
                    minValue={Opening.startWorkDay ? this.concatDateAndTime(new Date(), Opening.startWorkDay) : false}
                    maxValue={Opening.endWorkDay ? this.concatDateAndTime(new Date(), Opening.endWorkDay) : false}
                    validationCallBack={() => Opening.startWorkDay != null && Opening.endWorkDay != null}
                  />
                </div>
                <div className="col-4">
                  <h3><p>Horario Sábado</p></h3>
                  <RangeHoursWeek
                    key="hourWorkSaturday"
                    column="hourWorkSaturday"
                    disabled={!Opening.satWorking}
                    callBackHours={(data) => this.handleChangeSatWorkDay(data)}
                    min={this.concatDateAndTime(new Date(), centerConfig.minSatWork)}
                    max={this.concatDateAndTime(new Date(), centerConfig.maxSatWork)}
                    skipDefaultValues
                    useData={Opening.IdConfig}
                    minValue={Opening.satWorkstart ? this.concatDateAndTime(new Date(), Opening.satWorkstart) : false}
                    maxValue={Opening.satWorkEnd ? this.concatDateAndTime(new Date(), Opening.satWorkEnd) : false}
                    validationCallBack={() => Opening.satWorkstart != null && Opening.satWorkEnd != null}
                  />
                </div>
                <div className="col-4">
                  <h3><p>Horario Domingo</p></h3>
                  <RangeHoursWeek
                    key="hourWorkSunday"
                    column="hourWorkSunday"
                    disabled={!Opening.sunWorking}
                    callBackHours={(data) => this.handleChangeSunWorkDay(data)}
                    min={this.concatDateAndTime(new Date(), centerConfig.minSunWork)}
                    max={this.concatDateAndTime(new Date(), centerConfig.maxSunWork)}
                    skipDefaultValues
                    useData={Opening.IdConfig}
                    minValue={Opening.sunWorkStart ? this.concatDateAndTime(new Date(), Opening.sunWorkStart) : false}
                    maxValue={Opening.sunWorkEnd ? this.concatDateAndTime(new Date(), Opening.sunWorkEnd) : false}
                    validationCallBack={() => Opening.sunWorkStart != null && Opening.sunWorkEnd != null}
                  />
                </div>
              </div>
              <div className="row col-12">
                <div className="col-4 field-newDenuncia">
                  <h3><p>Fecha Inicio</p></h3>
                  <DateBox
                    type="date"
                    width={230}
                    placeholder="día/mes/año"
                    max={Opening.endDate}
                    displayFormat="dd/MM/yyyy"
                    showClearButton
                    disabledDates={this.props.feriadosAdministrativos}
                    onValueChanged={this.handleChangeDesde}
                    calendarOptions={{
                      cellTemplate: (data, index, element) => {
                        if (this.shouldDisableCalendarDay(data)) {
                          element.className = `${element.className} dx-calendar-empty-cell`;
                        }
                        ReactDOM.render(
                          <span>{data.text}</span>,
                          element
                        );
                      },
                    }}
                    value={Opening.startDate}
                    validationError={{ message: "Fecha indicada es mayor a la fecha final" }}
                  >
                    <Validator
                      validationRules={[{
                        type: "required",
                        message: "Este campo es requerido",
                      }]
                      }
                    />
                  </DateBox>

                </div>
                <div className="col-4 field-newDenuncia">
                  <h3><p>Fecha Fin</p></h3>
                  <DateBox
                    type="date"
                    width={230}
                    placeholder="día/mes/año"
                    disabledDates={this.props.feriadosAdministrativos}
                    displayFormat="dd/MM/yyyy"
                    showClearButton
                    calendarOptions={{
                      cellTemplate: (data, index, element) => {
                        if (this.shouldDisableCalendarDay(data)) {
                          element.className = `${element.className} dx-calendar-empty-cell`;
                        }
                        ReactDOM.render(
                          <span>{data.text}</span>,
                          element
                        );
                      },
                    }}
                    min={Opening.startDate}
                    onValueChanged={this.handleChangeHasta}
                    value={Opening.endDate}
                    validationError={{ message: "Fecha indicada es menor a la fecha inicial" }}
                  >
                    <Validator
                      validationRules={[{
                        type: "required",
                        message: "Este campo es requerido",
                      }]}
                    />
                  </DateBox>
                </div>
                <div className="col-4 field-newDenuncia">
                  <h3><p>Duración de Módulo</p></h3>
                  <SelectBox
                    id="moduleTime"
                    items={moduleTimeList}
                    value={Opening.moduleTime}
                    onValueChanged={this.handleChangModuleTime}
                    disabled={Opening.Id > 0}
                  >
                    <Validator
                      validationRules={[{
                        type: "required",
                        message: "Este campo es requerido",
                      }]}
                    />
                  </SelectBox>
                </div>
              </div>
              <div className="button-row">
                <div>
                  <Button
                    onClick={this.handleClose}
                    text="Cancelar"
                  />
                </div>
                <div>
                  <Button
                    onClick={this.handleNext}
                    type="success"
                    text="Siguiente"
                  />
                </div>
              </div>
            </ValidationGroup>
          </React.Fragment>
        )}

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  Opening: state.aperturasSel.Opening,
  configList: state.aperturasSel.configList,
  centrosList: state.aperturasSel.centrosList,
  listQuotes: state.aperturasSel.listQuotes,
  steps: state.aperturasSel.steps,
  isBackStep: state.aperturasSel.isBackStep,
  centerConfig: state.aperturasSel.centerConfig,
  isPopupWizardOpen: state.aperturasSel.isPopupWizardOpen,
  centerId: state.aperturasSel.centerId,
  isModalWizardLoading: state.aperturasSel.isModalWizardLoading,
  feriadosAdministrativos: state.aperturasSel.feriadosAdministrativos,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(formConfigApertura);
